import React from 'react';

const BY = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_185"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_185)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#D0091E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 0L5 1.5L3 3V0ZM3 3L5 4.5L3 6V3ZM3 6L5 7.5L3 9V6ZM3 9L5 10.5L3 12V9ZM3 12L5 13.5L3 15V12ZM2 0L0 1.5L2 3V0ZM2 3L0 4.5L2 6V3ZM2 6L0 7.5L2 9V6ZM2 9L0 10.5L2 12V9ZM2 12L0 13.5L2 15V12ZM2 0H3V2H2V0ZM2 13H3V15H2V13ZM2 5H3V7H2V5ZM2 3H3V4H2V3ZM2 11H3V12H2V11ZM2 8H3V10H2V8Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 11H21V15H5V11Z"
        fill="#46A753"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default BY;
